import Design1 from './design-1';
import Design2 from "./design-2";
import Design3 from "./design-3";

ProductCard.propTypes = {};

ProductCard.defaultProps = {};

const withCardActionForm = (product, formsByUuid) => {
    const formUuid = product?.cardAction?.formUuid;
    if (!formUuid || product?.cardAction?.form || !formsByUuid?.[formUuid]) return product;

    return {
        ...product,
        cardAction: {
            ...product.cardAction,
            form: formsByUuid[formUuid],
        }
    };
};

export default function ProductCard(props) {
    const product = withCardActionForm(props.product, props?.values?.cardActionForms);
    const designProps = {...props, product};
    const design = product?.salesEvent ? 0 : props.settings?.design;

    switch (design) {
        case 0 :
            return (<Design1 {...designProps} />);
        case 1 :
        case 'Syple.Velocity.Plugins.TruckDealer' :
            return (<Design2 {...designProps} />);
        case 2 :
        case 'Syple.Velocity.Plugins.CarDealer' :
            return (<Design3 {...designProps} />);
        default:
            return (<Design1 {...designProps} />);
    }
};
